(() => {
  const two = (value) => String(value).padStart(2, '0');

  function mountCarousel(root) {
    if (root.dataset.slMounted === 'true') return;
    root.dataset.slMounted = 'true';

    const track = root.querySelector('[data-sl-track]');
    const slides = Array.from(root.querySelectorAll('[data-sl-slide]'));
    const dots = Array.from(root.querySelectorAll('[data-sl-dot]'));
    const previous = root.querySelector('[data-sl-prev]');
    const next = root.querySelector('[data-sl-next]');
    const count = root.querySelector('[data-sl-count]');
    let index = 0;
    let touchStart = null;

    if (!track || slides.length === 0) return;

    const update = (requested, focusDot = false) => {
      index = (requested + slides.length) % slides.length;
      track.style.transform = `translate3d(-${index * 100}%, 0, 0)`;
      slides.forEach((slide, slideIndex) => {
        slide.setAttribute('aria-hidden', slideIndex === index ? 'false' : 'true');
      });
      dots.forEach((dot, dotIndex) => {
        dot.setAttribute('aria-current', dotIndex === index ? 'true' : 'false');
        dot.setAttribute('aria-label', `Show image ${dotIndex + 1} of ${slides.length}`);
      });
      if (count) count.textContent = `${two(index + 1)} / ${two(slides.length)}`;
      if (focusDot && dots[index]) dots[index].focus();
    };

    previous?.addEventListener('click', () => update(index - 1));
    next?.addEventListener('click', () => update(index + 1));
    dots.forEach((dot, dotIndex) => dot.addEventListener('click', () => update(dotIndex)));

    root.addEventListener('keydown', (event) => {
      if (event.key === 'ArrowLeft') { event.preventDefault(); update(index - 1); }
      if (event.key === 'ArrowRight') { event.preventDefault(); update(index + 1); }
      if (event.key === 'Home') { event.preventDefault(); update(0, true); }
      if (event.key === 'End') { event.preventDefault(); update(slides.length - 1, true); }
    });

    root.addEventListener('touchstart', (event) => {
      touchStart = event.changedTouches[0]?.clientX ?? null;
    }, { passive: true });
    root.addEventListener('touchend', (event) => {
      if (touchStart === null) return;
      const touchEnd = event.changedTouches[0]?.clientX ?? touchStart;
      const delta = touchEnd - touchStart;
      touchStart = null;
      if (Math.abs(delta) < 45) return;
      update(index + (delta < 0 ? 1 : -1));
    }, { passive: true });

    if (slides.length < 2) {
      if (previous) previous.disabled = true;
      if (next) next.disabled = true;
    }
    update(0);
    root.dataset.slReady = 'true';
  }

  function mountReveals(scope = document) {
    const targets = scope.querySelectorAll('[data-sl-reveal]:not(.sl-visible)');
    if (!('IntersectionObserver' in window)) {
      targets.forEach((target) => target.classList.add('sl-visible'));
      return;
    }
    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting) return;
        entry.target.classList.add('sl-visible');
        observer.unobserve(entry.target);
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 });
    targets.forEach((target) => observer.observe(target));
  }

  function mount(scope = document) {
    scope.querySelectorAll('[data-sl-product-carousel]').forEach(mountCarousel);
    mountReveals(scope);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => mount());
  } else {
    mount();
  }
  document.addEventListener('shopify:section:load', (event) => mount(event.target));
})();
